import { hasTriggerFormSubmit } from "@circle-react/helpers/hasTriggerFormSubmit";
import type { RefObject } from "react";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

export interface UseSubmitViaKeyboardProps {
  enabled?: boolean;
  targetRef?: RefObject<HTMLElement | null>;
}

export const useSubmitViaKeyboard = ({
  enabled = true,
  targetRef,
}: UseSubmitViaKeyboardProps = {}) => {
  const context = useFormContext();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const target = targetRef ? targetRef.current : document;
    if (!target) {
      return;
    }

    const listener = (event: Event) => {
      if (
        event instanceof KeyboardEvent &&
        event.key === "Enter" &&
        (event.metaKey || event.ctrlKey) &&
        hasTriggerFormSubmit(context)
      ) {
        context.triggerFormSubmit();
      }
    };

    target.addEventListener("keydown", listener);

    return () => {
      target.removeEventListener("keydown", listener);
    };
  }, [enabled, context, targetRef]);
};
